"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _mapping = require("@nicbase/mapping");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var PoiType = function PoiType(_ref) {
  var categoryType = _ref.categoryType,
      categoryName = _ref.categoryName,
      name = _ref.name;
  var Icon = (0, _mapping.getPoiCategoryIcon)(categoryType);
  return /*#__PURE__*/_react["default"].createElement("section", null, /*#__PURE__*/_react["default"].createElement(Icon, null), /*#__PURE__*/_react["default"].createElement("span", {
    className: "name"
  }, name), /*#__PURE__*/_react["default"].createElement("span", null), /*#__PURE__*/_react["default"].createElement("span", null, categoryName));
};

PoiType.propTypes = {
  categoryType: _propTypes["default"].string,
  categoryName: _propTypes["default"].string,
  name: _propTypes["default"].string
};
PoiType.defaultProps = {
  categoryType: 'default',
  name: '',
  categoryName: ''
};
var _default = PoiType;
exports["default"] = _default;